import { useSelector, useDispatch } from "react-redux";
import { GetShortFormOfString } from "../../../../utils/GetShortFormOfString";
import styles from "./IPCameraVideoStreaming.module.css";
import {
  userRoleKeyMap,
  userRoles,
  userSchoolName,
} from "../../../../utils/constant";
import { useState, useCallback } from "react";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import HoverToolTip from "../../../../Common/ToolTips/HoverToolTips/HoverToolTip";
import userService from "../../../../services/user.service";
import { openFailDialog } from "../../../../Redux/Actions/PopupActions";
import { throttle } from "lodash";

const ScoreBox = () => {
  const dispatch = useDispatch();
  const [score, setScore] = useState({
    team1Score: 0,
    team2Score: 0,
  });

  const userInfo = useSelector(({ loggedInUser }) => {
    const role = loggedInUser?.role;
    const user = loggedInUser[userRoleKeyMap[role]];
    return {
      schoolDetails:
        role == userRoles?.ROLE_SCHOOL_ADMIN
          ? user
          : user[userSchoolName[role]][0].school,
    };
  });

  const { videoStreamAvsChannelList } = useSelector(
    (state) => state?.videoStreamData
  );
  const videoScheduleInformation = useSelector(
    (state) => state?.videoScheduleInformation
  );

  const throttledUpdateMatchScore = throttle(
    (keyArray, scoreHomeSchool, scoreOpponentSchool) => {
      userService
        .updateMatchScore(keyArray, scoreHomeSchool, scoreOpponentSchool)
        .then((data) => {})
        .catch((error) => {
          openFailDialog(dispatch, {
            open: true,
            message: "Something Went Wrong",
          });
        });
    },
    1000
  );

  const updateScore = (name, type) => {
    setScore((prevState) => {
      const newScore = {
        ...prevState,
        [name]:
          type === "increment" ? prevState[name] + 1 : prevState[name] - 1,
      };

      const keyArray = videoStreamAvsChannelList.map((ele) => ele.streamKey);
      throttledUpdateMatchScore(
        keyArray,
        newScore.team1Score,
        newScore.team2Score
      );

      return newScore;
    });
  };

  return (
    <div className={styles.teamScoreContainer}>
      <div className={styles.teamScorbox}>
        <div className={styles.scoreItem}>
          <HoverToolTip
            content={<span>{userInfo?.schoolDetails?.schoolName}</span>}
            showToolTip={true}
            variant="sm"
            trigger="hover"
          >
            <p className="semi-bold fs-18">
              {GetShortFormOfString(userInfo?.schoolDetails?.schoolName)}
            </p>
          </HoverToolTip>
        </div>
        <input value={score.team1Score} name="team1Score" readOnly />
        <button onClick={() => updateScore("team1Score", "increment")}>
          <FaAngleUp />
        </button>
        <button onClick={() => updateScore("team1Score", "decrement")}>
          <FaAngleDown />
        </button>
      </div>
      <span className="semi-bold fs-20">VS</span>
      <div className={styles.teamScorbox}>
        <div className={styles.scoreItem}>
          <HoverToolTip
            content={<span>{videoScheduleInformation?.opponentName}</span>}
            showToolTip={true}
            variant="sm"
            trigger="hover"
          >
            <p className="semi-bold fs-18">
              {GetShortFormOfString(videoScheduleInformation?.opponentName)}
            </p>
          </HoverToolTip>
        </div>

        <input value={score.team2Score} name="team2Score" readOnly />
        <button onClick={() => updateScore("team2Score", "increment")}>
          <FaAngleUp />
        </button>
        <button onClick={() => updateScore("team2Score", "decrement")}>
          <FaAngleDown />
        </button>
      </div>
    </div>
  );
};

export default ScoreBox;
